import React, { useState } from 'react'
import UPLOAD from '../assets/images/upload.png'
import { IoMdClose } from "react-icons/io";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const UploadImg = () => {
    const uploadSlider = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },

            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };
    const [selectedimages, setselectedimages] = useState([]);

    const onSelectFile = (Event) => {
        const selectedFiles = Event.target.files;
        const selectedfileArray = Array.from(selectedFiles);

        const imagesArray = selectedfileArray.map((file) => {
            return URL.createObjectURL(file);
        });
        setselectedimages(imagesArray)
    }

    return (
        <>
            <div className='upload_imgea_section'>
                <label className='img_uload_button_new'>
                    <span>
                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12.7419 10.6228C12.7234 10.6079 12.7053 10.5936 12.6875 10.5797V19.25C12.6875 19.7678 12.2678 20.1875 11.75 20.1875C11.2322 20.1875 10.8125 19.7678 10.8125 19.25V10.5797C10.7947 10.5936 10.7766 10.6079 10.7581 10.6228C10.3548 10.9467 9.87541 11.4284 9.16317 12.147L7.41586 13.9099C7.05138 14.2777 6.4578 14.2803 6.09005 13.9159C5.72231 13.5514 5.71966 12.9578 6.08414 12.59L7.86956 10.7886C8.5338 10.1184 9.08778 9.55942 9.58405 9.16086C10.1046 8.74283 10.6516 8.42487 11.3181 8.33991C11.6049 8.30336 11.8951 8.30336 12.1819 8.33991C12.8484 8.42487 13.3954 8.74283 13.9159 9.16086C14.4122 9.55942 14.9662 10.1184 15.6304 10.7886L17.4159 12.5901C17.7803 12.9578 17.7777 13.5514 17.41 13.9159C17.0422 14.2803 16.4486 14.2777 16.0841 13.9099L14.3368 12.147C13.6246 11.4284 13.1452 10.9467 12.7419 10.6228Z" fill="#0D0D0D" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7821 0.849211C15.7106 0.8125 14.4639 0.8125 13.0138 0.8125H12.9434C10.6478 0.81249 8.84827 0.812482 7.4206 0.96716C5.96367 1.12501 4.7832 1.45291 3.77529 2.18519C3.16511 2.62851 2.62851 3.16511 2.18519 3.77529C1.45291 4.7832 1.12501 5.96367 0.96716 7.4206C0.812482 8.84826 0.81249 10.6478 0.8125 12.9434V13.0566C0.81249 15.3522 0.812482 17.1517 0.96716 18.5794C1.12501 20.0363 1.45291 21.2168 2.18519 22.2247C2.62851 22.8349 3.16511 23.3715 3.77529 23.8148C4.7832 24.5471 5.96367 24.875 7.4206 25.0328C8.84824 25.1875 10.6477 25.1875 12.9433 25.1875H13.0566C15.3522 25.1875 17.1518 25.1875 18.5794 25.0328C20.0363 24.875 21.2168 24.5471 22.2247 23.8148C22.8349 23.3715 23.3715 22.8349 23.8148 22.2247C24.5471 21.2168 24.875 20.0363 25.0328 18.5794C25.1875 17.1518 25.1875 15.3523 25.1875 13.0567V12.9862C25.1875 11.5361 25.1875 10.2894 25.1508 9.2179C25.0706 6.87609 24.8171 5.15487 23.8148 3.77529C23.3715 3.16511 22.8349 2.62851 22.2247 2.18519C20.8451 1.18287 19.1239 0.929444 16.7821 0.849211ZM4.87739 3.7021C5.5124 3.24074 6.32517 2.97181 7.62256 2.83125C8.93749 2.68879 10.6355 2.6875 13 2.6875C14.0604 2.6875 14.9897 2.68756 15.8148 2.70102C15.8202 3.29433 15.8387 3.73112 15.901 4.12437C16.3881 7.19985 18.8001 9.6119 21.8756 10.099C22.2689 10.1613 22.7057 10.1798 23.299 10.1852C23.3124 11.0103 23.3125 11.9396 23.3125 13C23.3125 15.3645 23.3112 17.0625 23.1688 18.3774C23.0282 19.6748 22.7593 20.4876 22.2979 21.1226C21.9702 21.5736 21.5736 21.9702 21.1226 22.2979C20.4876 22.7593 19.6748 23.0282 18.3774 23.1688C17.0625 23.3112 15.3645 23.3125 13 23.3125C10.6355 23.3125 8.93749 23.3112 7.62256 23.1688C6.32517 23.0282 5.5124 22.7593 4.87739 22.2979C4.42639 21.9702 4.02977 21.5736 3.7021 21.1226C3.24074 20.4876 2.97181 19.6748 2.83125 18.3774C2.68879 17.0625 2.6875 15.3645 2.6875 13C2.6875 10.6355 2.68879 8.93749 2.83125 7.62256C2.97181 6.32517 3.24074 5.5124 3.7021 4.87739C4.02977 4.42639 4.42639 4.02977 4.87739 3.7021ZM17.7529 3.83106C17.7123 3.57477 17.6968 3.27798 17.691 2.7718C19.3914 2.88902 20.3733 3.15769 21.1226 3.7021C21.5736 4.02977 21.9702 4.42639 22.2979 4.87739C22.8423 5.62671 23.111 6.60859 23.2282 8.30902C22.722 8.30317 22.4252 8.28769 22.1689 8.24709C19.8958 7.88706 18.1129 6.10424 17.7529 3.83106Z" fill="#0D0D0D" />
                        </svg>
                    </span>
                    <span>Upload image</span>
                    <input type='file' name='images' onChange={onSelectFile} multiple accept='image/png, image/jpeg, image/webp' />
                </label>
                <ul className='uploadetImges'>
                    <Slider {...uploadSlider}>
                        {

                            selectedimages.map((image, index) => {
                                return (
                                    <li key={image}>
                                        <img src={image} alt='images' />
                                        <p
                                            onClick={() => setselectedimages(selectedimages.filter((e) => e !== image))}
                                            className='delete_button_img'><IoMdClose />
                                        </p>
                                    </li>
                                )
                            })
                        }
                    </Slider>
                </ul>
            </div>
        </>
    )
}

export default UploadImg
